
@if (showalert==true) {
  <div>
    <app-alert [message]="message" [msgtype]="msgtype"></app-alert>
  </div>
}
<div class="font-20 semibold mtb-20">
  Review and Submit
</div>
<div class="container mb-10">
  <!-- Only when it's annual contact verification show this message - kevin.low 08/06/24 -->
  @if (cService.tokenDtls.annualVerification=='True') {
    It has been a while since you last verified your contact information. Please review your contact information to ensure it is accurate and up-to-date.
  }
  @else{
  Please review your contact information.
}
You may make corrections by clicking the Edit button in that section. Click the <b>Submit</b> button when finished.
</div>
<div>
  <ul class="review">
    @if (homeEmail) {
      <li>
        <div class="card fluid">
          <div class="card__content">
            <div class="flex width-full">
              <div class="m-auto">
                <button title="Edit" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit" (click)="updatestep(2,'homeEmail',null,null)">
                  <div class="icon icon-black">
                    <i class="fas fa-pen"></i>
                  </div>
                </button>
              </div>
              <div class="width-full mt-10 pl-20">
                <div class="mb-10">
                  <b>Personal Email</b>
                </div>
                <div class="mb-10">
                  {{ homeEmail?.email}}
                </div>
              </div>
            </div>
            <div class="icon-container absolute">
              <i class="fas fa-check"></i>
            </div>
          </div>
        </div>
      </li>
    }
    @if (officeEmail?.length!=0) {
      <li>
        <div class="card fluid">
          <div class="card__content">
            <div class="flex width-full">
              <div class="m-auto">
                <button title="Edit" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit" (click)="updatestep(3,'officeEmail',null,null)">
                  <div class="icon icon-black">
                    <i class="fas fa-pen"></i>
                  </div>
                </button>
              </div>
              <div class="width-full mt-10 pl-20">
                <div class="mb-10">
                  <b>Office Email</b>
                </div>
                <div class="mb-10">
                  @for (oemail of officeEmail; track oemail; let ind = $index) {
                    {{oemail?.email}}
                    @if (ind!== (officeEmail.length-1)) {
                      <span>, </span>
                    }
                  }
                </div>
              </div>
            </div>
            <div class="icon-container absolute">
              <i class="fas fa-check"></i>
            </div>
          </div>
        </div>
      </li>
    }
    @if (homePhysicalAddress?.addressI!=null) {
      <li>
        <div class="card fluid">
          <div class="card__content">
            <div class="flex width-full">
              <div class="m-auto">
                <button title="Edit" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit" (click)="updatestep(4,'Address1',homePhysicalAddress,null)">
                  <div class="icon icon-black">
                    <i class="fas fa-pen"></i>
                  </div>
                </button>
              </div>
              <div class="width-full mt-10 pl-20">
                <div class="mb-10">
                  <b>Home Physical Address</b>
                </div>
                <div class="mb-10">
                  {{homePhysicalAddress?.addressI}},
                  {{homePhysicalAddress?.city}},
                  {{homePhysicalAddress.state}},
                  {{homePhysicalAddress?.zipCode}}@if (homePhysicalAddress.zipCode4) {
                  <span>-{{homePhysicalAddress?.zipCode4}}</span>
                }
              </div>
            </div>
          </div>
          <div class="icon-container absolute">
            <i class="fas fa-check"></i>
          </div>
        </div>
      </div>
    </li>
  }
  @if (homeMailingAddress?.addressI!=null) {
    <li>
      <div class="card fluid">
        <div class="card__content">
          <div class="flex width-full">
            <div class="m-auto">
              <button title="Edit" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit" (click)="updatestep(4,'Address2',homeMailingAddress,null)">
                <div class="icon icon-black">
                  <i class="fas fa-pen"></i>
                </div>
              </button>
            </div>
            <div class="width-full mt-10 pl-20">
              <div class="mb-10">
                <b>Home Mailing Address</b>
              </div>
              <div class="mb-10">
                {{homeMailingAddress?.addressI}},
                {{homeMailingAddress?.city}},
                {{homeMailingAddress.state}},
                {{homeMailingAddress?.zipCode}}@if (homeMailingAddress.zipCode4) {
                <span>-{{homeMailingAddress?.zipCode4}}</span>
              }
            </div>
          </div>
        </div>
        <div class="icon-container absolute">
          <i class="fas fa-check"></i>
        </div>
      </div>
    </div>
  </li>
}
@if (officeMailingAddress?.addressI!=null) {
  <li>
    <div class="card fluid">
      <div class="card__content">
        <div class="flex width-full">
          <div class="m-auto">
            <button title="Edit" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit" (click)="updatestep(4,'Address3',officeMailingAddress,null)">
              <div class="icon icon-black">
                <i class="fas fa-pen"></i>
              </div>
            </button>
          </div>
          <div class="width-full mt-10 pl-20">
            <div class="mb-10">
              <b>Office Mailing Address</b>
            </div>
            <div class="mb-10">
              {{officeMailingAddress?.addressI}},
              {{officeMailingAddress?.city}},
              {{officeMailingAddress.state}},
              {{officeMailingAddress?.zipCode}}@if (officeMailingAddress.zipCode4) {
              <span>-{{officeMailingAddress?.zipCode4}}</span>
            }
          </div>
        </div>
      </div>
      <div class="icon-container absolute">
        <i class="fas fa-check"></i>
      </div>
    </div>
  </div>
</li>
}
@if (officePhysicalAddress?.addressI!=null) {
  <li>
    <div class="card fluid">
      <div class="card__content">
        <div class="flex width-full">
          <div class="m-auto">
            <button title="Edit" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit" (click)="updatestep(4,'Address4',officePhysicalAddress,null)">
              <div class="icon icon-black">
                <i class="fas fa-pen"></i>
              </div>
            </button>
          </div>
          <div class="width-full mt-10 pl-20">
            <div class="mb-10">
              <b>Office Physical Address</b>
            </div>
            <div class="mb-10">
              {{officePhysicalAddress?.addressI}},
              {{officePhysicalAddress?.city}},
              {{officePhysicalAddress.state}},
              {{officePhysicalAddress?.zipCode}}@if (officePhysicalAddress.zipCode4) {
              <span>-{{officePhysicalAddress?.zipCode4}}</span>
            }
          </div>
        </div>
      </div>
      <div class="icon-container absolute">
        <i class="fas fa-check"></i>
      </div>
    </div>
  </div>
</li>
}
@if (officePhoneDtls?.areaCode!=null) {
  <li>
    <div class="card fluid">
      <div class="card__content">
        <div class="flex width-full">
          <div class="m-auto">
            <button title="Edit" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit" (click)="updatestep(5,'Phone1',null,officePhoneDtls)">
              <div class="icon icon-black">
                <i class="fas fa-pen"></i>
              </div>
            </button>
          </div>
          <div class="width-full mt-10 pl-20">
            <div class="mb-10">
              <b>Office Phone Number (Primary) </b>
            </div>
            <div class="mb-10">
              ({{officePhoneDtls?.areaCode}}) {{ officePhoneDtls?.phoneNumberDisplay}}
            </div>
          </div>
        </div>
        <div class="icon-container absolute">
          <i class="fas fa-check"></i>
        </div>
      </div>
    </div>
  </li>
}
@if (homePhoneDtls?.areaCode!=null) {
  <li>
    <div class="card fluid">
      <div class="card__content">
        <div class="flex width-full">
          <div class="m-auto">
            <button title="Edit" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit" (click)="updatestep(5,'Phone2',null,homePhoneDtls)">
              <div class="icon icon-black">
                <i class="fas fa-pen"></i>
              </div>
            </button>
          </div>
          <div class="width-full mt-10 pl-20">
            <div class="mb-10">
              <b>Home Phone Number</b>
            </div>
            <div class="mb-10">
              ({{homePhoneDtls?.areaCode}}) {{homePhoneDtls?.phoneNumberDisplay}}
            </div>
          </div>
        </div>
        <div class="icon-container absolute">
          <i class="fas fa-check"></i>
        </div>
      </div>
    </div>
  </li>
}
@if (mobilePhoneDtls?.areaCode!=null) {
  <li>
    <div class="card fluid">
      <div class="card__content">
        <div class="flex width-full">
          <div class="m-auto">
            <button title="Edit" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit" (click)="updatestep(5,'Phone3',null,mobilePhoneDtls)">
              <div class="icon icon-black">
                <i class="fas fa-pen"></i>
              </div>
            </button>
          </div>
          <div class="width-full mt-10 pl-20">
            <div class="mb-10">
              <b>Cell Phone Number</b>
            </div>
            <div class="mb-10">
              ({{mobilePhoneDtls?.areaCode}}) {{mobilePhoneDtls?.phoneNumberDisplay}}
            </div>
          </div>
        </div>
        <div class="icon-container absolute">
          <i class="fas fa-check"></i>
        </div>
      </div>
    </div>
  </li>
}
</ul>
</div>
<div class="divider gray-500 mtb-20"></div>
<div class="container flex mobile">
  <span class="basis-33">
    <span class="flex justify-start">
      <button title="Back" id="" class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="updatestepcount()">
        <div class="btn-txt font-red bold">Back</div>
      </button>
    </span>
  </span>
  <span class="basis-33">
    <span class="flex justify-center">
      <!--<button title="Skip Verification" id="" class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="cService.backtoapplication()">
      <div class="btn-txt font-red bold">Skip Verification for Now</div>
    </button>-->
  </span>
</span>
<span class="basis-33">
  <span class="flex justify-end">
    <button title="Submit" class="rounded-full hover-blue-800 black mobile" (click)="submitContactVerification()">
      <div class="btn-txt font-white bold">Submit</div>
    </button>
  </span>
</span>
</div>
